import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { puede } from "../../../../permisos/permisos";

function ListadoOrdenesCompraArticulos() {
  const { user } = useContext(AuthContext);
  const URL_OCA = process.env.REACT_APP_URL_ORDENES_COMPRA_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);
  let fin = new Date();
  fin.setDate(fin.getDate() + 1); // margen por zona horaria
  let endDate = moment(fin).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [coloresCat, setColoresCat] = useState([]);

  // Alta / edición
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [proveedor, setProveedor] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [moneda, setMoneda] = useState("MXN");
  const [tipoCambio, setTipoCambio] = useState(0);
  const [lineas, setLineas] = useState([{ articulo: "", color: "", cantidad: 1, costo: 0, observaciones: "" }]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    getOrdenes();
    axios.get(URL_PROVEEDORES, headers).then((r) => setProveedores(r.data)).catch((e) => console.log(e));
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_COLORES, headers).then((r) => setColoresCat(r.data)).catch((e) => console.log(e));
  }, []);

  // Solo los colores dados de alta en el articulo.
  function coloresDeArticulo(idArticulo) {
    const art = articulos.find((a) => a._id === idArticulo);
    return (art && art.colores) || [];
  }

  function getOrdenes() {
    axios
      .get(URL_OCA, headers)
      .then((r) => {
        let allOrdenes = r.data;
        let arrayTabla = allOrdenes.map((a) => {
          return {
            _id: a._id,
            idOCA: a.idOCA,
            fecha: a.fecha,
            proveedor: a.proveedor ? a.proveedor.nombre_comercial : "NA",
            numArticulos: (a.articulos || []).length,
            cantidadPedida: (a.articulos || []).reduce((t, l) => t + Number(l.cantidad || 0), 0),
            cantidadRecibida: (a.articulos || []).reduce((t, l) => t + Number(l.recibida || 0), 0),
            pendienteRecibir: (a.articulos || []).reduce((t, l) => t + Math.max(Number(l.cantidad || 0) - Number(l.recibida || 0), 0), 0),
            total: a.total || 0,
            moneda: a.moneda || "MXN",
            estado: a.estado,
            raw: a,
          };
        });
        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
      })
      .catch((e) => console.log(e));
  }

  // Solo artículos comerciales (tapas, difusores, etc.).
  const articulosComerciales = articulos.filter((a) => a.tipo_articulo === "Comercial");

  // ---- Alta ----
  function abreNuevo() {
    setIdEdit(null);
    setFecha(moment().format("YYYY-MM-DD"));
    setProveedor(""); setObservaciones(""); setMoneda("MXN"); setTipoCambio(0);
    setLineas([{ articulo: "", color: "", cantidad: 1, costo: 0, observaciones: "" }]);
    toggle();
  }
  // Editar una orden mientras esté Pendiente.
  function abreEdit(oca) {
    setIdEdit(oca._id);
    setFecha(oca.fecha || moment().format("YYYY-MM-DD"));
    setProveedor(oca.proveedor ? (oca.proveedor._id || oca.proveedor) : "");
    setObservaciones(oca.observaciones === "NA" ? "" : (oca.observaciones || ""));
    setMoneda(oca.moneda || "MXN");
    setTipoCambio(oca.tipoCambio || 0);
    setLineas(
      (oca.articulos || []).map((l) => ({
        articulo: l.articulo ? (l.articulo._id || l.articulo) : "",
        color: l.color ? (l.color._id || l.color) : "",
        cantidad: l.cantidad,
        costo: l.costo,
        observaciones: l.observaciones || "",
      }))
    );
    toggle();
  }
  function setLinea(i, campo, valor) {
    setLineas((prev) => prev.map((l, idx) => (idx === i ? { ...l, [campo]: valor } : l)));
  }
  function addLinea() { setLineas((prev) => [...prev, { articulo: "", color: "", cantidad: 1, costo: 0, observaciones: "" }]); }
  function removeLinea(i) { setLineas((prev) => prev.filter((_, idx) => idx !== i)); }
  const totalAlta = lineas.reduce((a, l) => a + Number(l.cantidad || 0) * Number(l.costo || 0), 0);

  function guardar() {
    const lineasValidas = lineas.filter((l) => l.articulo && Number(l.cantidad) > 0);
    if (!lineasValidas.length) {
      Swal.fire("Atención", "Agrega al menos un artículo con cantidad", "warning");
      return;
    }
    const body = {
      fecha, proveedor: proveedor || null, observaciones: observaciones || "NA",
      moneda, tipoCambio: Number(tipoCambio) || 0,
      articulos: lineasValidas.map((l) => ({
        articulo: l.articulo, ...(l.color ? { color: l.color } : {}), cantidad: Number(l.cantidad), costo: Number(l.costo),
        observaciones: l.observaciones || "",
      })),
    };
    const req = idEdit
      ? axios.patch(`${URL_OCA}/${idEdit}`, body, headers)
      : axios.post(URL_OCA, body, headers);
    req
      .then(() => {
        axios.post(URL_LOGS, { tipo: idEdit ? "Editar OC Articulos" : "Crear OC Articulos", detalle: `${lineasValidas.length} articulos`, user: user.id }, headers);
        toggle();
        Swal.fire("Good job!", idEdit ? "Orden de compra actualizada" : "Orden de compra creada", "success");
        window.location.reload();
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` }));
  }

  function cancelar(oca) {
    Swal.fire({
      title: "Cancelar orden?", icon: "warning", showCancelButton: true,
      confirmButtonText: "Sí, cancelar", cancelButtonText: "No",
    }).then((r) => {
      if (r.isConfirmed) {
        axios.patch(`${URL_OCA}Cancelar/${oca._id}`, {}, headers)
          .then(() => { Swal.fire("Cancelada", "", "success"); window.location.reload(); })
          .catch((e) => console.log(e));
      }
    });
  }

  // Cierra la orden: ya no se recibe más (aunque quede pendiente).
  function cerrar(oca) {
    Swal.fire({
      title: "Cerrar orden?",
      text: "Ya no se podrá recibir más de esta orden.",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Sí, cerrar", cancelButtonText: "No",
    }).then((r) => {
      if (r.isConfirmed) {
        axios.patch(`${URL_OCA}Cerrar/${oca._id}`, {}, headers)
          .then(() => { Swal.fire("Cerrada", "", "success"); window.location.reload(); })
          .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data.message || error.response.data : error}` }));
      }
    });
  }

  // PDF de la orden de compra de Producto Terminado.
  function PDFOC(oca) {
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 12, 45, 15);
    doc.setFontSize(14);
    doc.text(`Orden de Compra PT # ${oca.idOCA}`, 14, 18);
    doc.setFontSize(11);
    doc.text(`Fecha: ${oca.fecha}`, 14, 26);
    doc.text(`Proveedor: ${oca.proveedor ? oca.proveedor.nombre_comercial : "NA"}`, 14, 32);
    doc.text(`Estado: ${oca.estado}`, 14, 38);
    const body = (oca.articulos || []).map((l) => [
      l.articulo ? l.articulo.descripcion : "-",
      l.color ? l.color.name : "-",
      l.cantidad,
      "$" + Number(l.costo || 0).toLocaleString("es-MX"),
      "$" + Number((l.cantidad || 0) * (l.costo || 0)).toLocaleString("es-MX"),
      l.observaciones || "",
    ]);
    doc.autoTable({
      head: [["Artículo", "Color", "Cantidad", "Precio", "Total", "Observaciones"]],
      body,
      startY: 44,
      foot: [["", "", "", "Total", "$" + Number(oca.total || 0).toLocaleString("es-MX"), ""]],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  const badgeEstado = (e) => {
    const map = { Recibida: "success", Parcial: "warning", Cancelada: "danger", Cerrada: "dark", Pendiente: "secondary" };
    return <span className={`badge badge-${map[e] || "secondary"}`}>{e}</span>;
  };

  const tableHeaders = [
    { name: "Folio", field: "idOCA", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: false },
    { name: "# Artículos", field: "numArticulos", sortable: false },
    { name: "Cant. Pedida", field: "cantidadPedida", sortable: false },
    { name: "Cant. Recibida", field: "cantidadRecibida", sortable: false },
    { name: "Pend. Recibir", field: "pendienteRecibir", sortable: false },
    { name: "Total", field: "total", sortable: true },
    { name: "Estado", field: "estado", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          (comment.proveedor || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.estado || "").toLowerCase().includes(search.toLowerCase()) ||
          comment.total.toString().includes(search) ||
          comment.idOCA.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter((e) => e.fecha >= selectedFechaInicio);
    }
    if (selectedFechaFin) {
      computedComments = computedComments.filter((e) => e.fecha <= selectedFechaFin);
    }

    setTotalItems(computedComments.length);

    if (sorting.field && sorting.field != "idOCA" && sorting.field != "total") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * (a[sorting.field] || "").toString().localeCompare((b[sorting.field] || "").toString())
      );
    }
    if (sorting.field && sorting.order === "asc" && (sorting.field == "idOCA" || sorting.field == "total")) {
      computedComments = computedComments.sort((a, b) => (parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1));
    }
    if (sorting.field && sorting.order === "desc" && (sorting.field == "idOCA" || sorting.field == "total")) {
      computedComments = computedComments.sort((a, b) => (parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1));
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedFechaInicio, selectedFechaFin]);

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "compras.ocPT.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-boxes" style={{ marginRight: 8, color: "#0ea5e9" }} />
                  Órdenes de Compra — Producto Terminado
                </h3>
                <p className="page-subtitle">Alta de órdenes de compra de Producto Terminado</p>
              </div>
              <div className="page-actions">
                {puede(user, "compras.ocPT.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Orden
                </Button>
)}
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
              <div className="col-md-4 d-flex flex-row-reverse">
                <Search
                  onSearch={(value) => {
                    setSearch(value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Inicio</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={selectedFechaInicio}
                  required
                  onChange={(e) => {
                    setSelectedFechaInicio(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Fin</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={selectedFechaFin}
                  required
                  onChange={(e) => {
                    setSelectedFechaFin(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <TableHeader
                headers={tableHeaders}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOCA}</td>
                    <td>{o.fecha}</td>
                    <td>{o.proveedor}</td>
                    <td>{o.numArticulos}</td>
                    <td>{Number(o.cantidadPedida || 0).toLocaleString("es-MX")}</td>
                    <td>{Number(o.cantidadRecibida || 0).toLocaleString("es-MX")}</td>
                    <td>{Number(o.pendienteRecibir || 0).toLocaleString("es-MX")}</td>
                    <td>${Number(o.total || 0).toLocaleString("es-MX")} {o.moneda === "USD" ? "USD" : ""}</td>
                    <td>{badgeEstado(o.estado)}</td>
                    <td>
                      <Button color="danger" size="sm" onClick={() => PDFOC(o.raw)} title="PDF" style={{ marginRight: 4 }}>
                        <i className="far fa-file-pdf"></i>
                      </Button>
                      {o.estado === "Pendiente" && (
                        puede(user, "compras.ocPT.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(o.raw)} title="Editar" style={{ marginRight: 4 }}>
                          <i className="fas fa-edit"></i>
                        </Button>
)
                      )}
                      {o.estado !== "Cancelada" && o.estado !== "Cerrada" && (
                        <Button color="warning" size="sm" onClick={() => cerrar(o.raw)} title="Cerrar orden" style={{ marginRight: 4 }}>
                          <i className="fas fa-lock"></i>
                        </Button>
                      )}
                      {o.estado !== "Recibida" && o.estado !== "Cancelada" && o.estado !== "Cerrada" && (
                        puede(user, "compras.ocPT.cancelar") && (
<Button color="danger" size="sm" onClick={() => cancelar(o)} title="Cancelar">
                          <i className="fas fa-ban"></i>
                        </Button>
)
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="xxl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-plus" style={{ marginRight: 8, color: "#0ea5e9" }} />
          {idEdit ? "Editar" : "Nueva"} Orden de Compra de Producto Terminado
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={5}>
              <Label>Proveedor</Label>
              <Input type="select" value={proveedor} onChange={(e) => setProveedor(e.target.value)}>
                <option value="">Selecciona...</option>
                {proveedores.map((p) => (
                  <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Fecha</Label>
              <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Label>Artículos comerciales</Label>
          {articulosComerciales.length === 0 && (
            <p className="text-muted" style={{ fontSize: "0.82rem" }}>
              No hay artículos marcados como <b>Comercial</b>. Márcalos en Config Plásticos.
            </p>
          )}
          <Row className="align-items-center" style={{ marginBottom: 4 }}>
            <Col md={3}><small className="text-muted" style={{ fontWeight: 600 }}>Artículo</small></Col>
            <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Color</small></Col>
            <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Cantidad</small></Col>
            <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Precio</small></Col>
            <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Observaciones</small></Col>
            <Col md={1}></Col>
          </Row>
          {lineas.map((l, i) => (
            <Row key={i} className="align-items-center" style={{ marginBottom: 6 }}>
              <Col md={3}>
                <Input type="select" bsSize="sm" value={l.articulo} onChange={(e) => setLinea(i, "articulo", e.target.value)}>
                  <option value="">Selecciona artículo...</option>
                  {articulosComerciales.map((a) => (
                    <option key={a._id} value={a._id}>{a.descripcion}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Input type="select" bsSize="sm" value={l.color} onChange={(e) => setLinea(i, "color", e.target.value)}>
                  <option value="">Color...</option>
                  {coloresDeArticulo(l.articulo)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((c) => (
                      <option key={c._id} value={c._id}>{c.name}</option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Input type="number" bsSize="sm" placeholder="Cant." value={l.cantidad} onChange={(e) => setLinea(i, "cantidad", e.target.value)} />
              </Col>
              <Col md={2}>
                <Input type="number" bsSize="sm" placeholder="Costo" value={l.costo} onChange={(e) => setLinea(i, "costo", e.target.value)} />
              </Col>
              <Col md={2}>
                <Input type="text" bsSize="sm" placeholder="Observaciones" value={l.observaciones} onChange={(e) => setLinea(i, "observaciones", e.target.value)} />
              </Col>
              <Col md={1}>
                <Button size="sm" color="danger" disabled={lineas.length === 1} onClick={() => removeLinea(i)}>
                  <i className="fas fa-minus"></i>
                </Button>{" "}
                <Button size="sm" color="info" onClick={addLinea}>
                  <i className="fas fa-plus"></i>
                </Button>
              </Col>
            </Row>
          ))}
          <br />
          <div style={{ textAlign: "right", fontWeight: 600 }}>
            Total: ${totalAlta.toLocaleString("es-MX")}
          </div>
          <br />
          <Row>
            <Col md={4}>
              <Label>Moneda</Label>
              <Input type="select" value={moneda} onChange={(e) => { setMoneda(e.target.value); if (e.target.value === "MXN") setTipoCambio(0); }}>
                <option value="MXN">Pesos (MXN)</option>
                <option value="USD">Dólares (USD)</option>
              </Input>
            </Col>
            {moneda === "USD" && (
              <Col md={4}>
                <Label>Tipo de cambio</Label>
                <Input type="number" placeholder="Ej. 17.50" value={tipoCambio} onChange={(e) => setTipoCambio(e.target.value)} />
              </Col>
            )}
          </Row>
          <br />
          <Label>Observaciones</Label>
          <Input type="textarea" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoOrdenesCompraArticulos;
